import React from 'react';
import PropTypes from 'prop-types';

const barText = {
  title: 'Your tab is open!',
  desc1:
    'When ordering, simply let your bartender know you already have a tab under your name and that you are using Vēmos Pay.',
  desc2:
    'Once items are added to your tab, click the refresh button and you will see them appear here.',
};

const tableText = {
  title: 'Your check is open!',
  desc1:
    'Just order with your server and let them know you are using Vēmos Pay.',
  desc2:
    'Once items are added to your check, click the refresh button and you will see them appear here.',
};

function EmptyMenu({ isTable }) {
  const texts = isTable ? tableText : barText;

  return (
    <div className="ion-padding center-flex-content mb-3x">
      <h2>{texts.title}</h2>
      <h6>{texts.desc1}</h6>
      <h6>
        <b>{texts.desc2}</b>
      </h6>
    </div>
  );
}

EmptyMenu.propTypes = {
  isTable: PropTypes.bool,
};

export default EmptyMenu;
